<template>
    <div class="d-flex justify-content-start container-all">
        <div class="sidebar">
            <Sidebar openSidebar="false"></Sidebar>
        </div>
        <div ref="mainPanel" class="main-panel">
            <Topbar class="topbar" />
            <div class="main-panel1">
                <LoaderVue v-if="isLoading" />
                <slot />
            </div>
        </div>
        <Dialog :draggable="false" :closable="false" v-model:visible="showPopup" modal header="Inactive" :style="{ width: '50vw' }">
            <p>
                Looks like you are inactive for 15 mins. Please click stay to continue your session or it will be automatically logged out after 5 more mins.
            </p>
            <template #footer>
                <Button label="Logout" @click="logout" text />
                <Button label="Stay" @click="resetInactivityTimer('stay')" />
            </template>
        </Dialog>
    </div>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue'
import Topbar from '@/components/Topbar.vue'
import { mapGetters } from 'vuex'
import LoaderVue from '@/components/common/Loader.vue'

export default {
    name: 'DefaultLayout',
    data () {
        return {
            inactivityTimeout: null,
            showPopup: false
        }
    },
    components: {
        Sidebar, LoaderVue, Topbar
    },
    computed: {
        ...mapGetters({ isLoading: 'isLoading' })
    },
    methods: {
        syncInactivityTimer () {
            // Check if the inactivity timer is already running in another tab
            const sharedTimeout = localStorage.getItem('inactivityTimeout')

            if (sharedTimeout) {
                // If a shared timer exists, use its remaining time
                const timeRemaining = JSON.parse(sharedTimeout).endTime - Date.now()

                if (timeRemaining > 0) {
                    this.startInactivityTimer(timeRemaining)
                    return
                }
            }

            // If no shared timer or it has expired, start a new one
            this.startInactivityTimer()
        },
        startInactivityTimer (timeRemaining) {
            // Set the inactivity timer (adjust the time as needed, e.g., 30 minutes)
            this.inactivityTimeout = setTimeout(() => {
                // Perform your inactivity action here (e.g., log out the user)
                this.showPopup = true
                this.startInactivityTimerAfterPopup()
            }, timeRemaining || 15 * 60 * 1000) // 30 minutes
        },
        startInactivityTimerAfterPopup () {
            this.inactivityTimeout = setTimeout(() => {
                this.performInactivityAction()
            }, 5 * 60 * 1000)
        },
        resetInactivityTimer (action) {
            if (this.showPopup && action === 'stay') {
                this.showPopup = false
                this.clearInactivityTimer()
                if (!localStorage.token) {
                    this.$router.push('/signin')
                } else {
                // Reset the inactivity timer when user clicks with the stay
                    this.startInactivityTimer()
                }
            }
            if (!this.showPopup) {
                // Reset the inactivity timer when user interacts with the page
                this.clearInactivityTimer()
                this.startInactivityTimer()
            }
        },
        clearInactivityTimer () {
            // Clear the inactivity timer if it's running
            if (this.inactivityTimeout) {
                clearTimeout(this.inactivityTimeout)
                this.inactivityTimeout = null
            }
        },
        async performInactivityAction () {
            // Implement your inactivity action here (e.g., log out the user)
            await this.logout()

            // Clear the inactivity timer and update the shared timer
            this.clearInactivityTimer()
            localStorage.removeItem('inactivityTimeout')
        },
        async logout () {
            const resp = await this.$store.dispatch('Auth/Logout/logout')
            if (resp) {
                this.showPopup = false
                this.$router.push('/signin')
            }
        }
    },
    beforeDestroy () {
        // Clean up event listeners when the component is destroyed
        window.removeEventListener('mousemove', this.resetInactivityTimer)
        window.removeEventListener('keydown', this.resetInactivityTimer)

        // Clear the inactivity timer
        this.clearInactivityTimer()
    },
    async mounted () {
        window.addEventListener('mousemove', this.resetInactivityTimer)
        window.addEventListener('keydown', this.resetInactivityTimer)

        // Start or synchronize the inactivity timer when the component is mounted
        this.syncInactivityTimer()
        await this.$store.dispatch('checkSubscription')
    }
}
</script>
<style scoped>
.main-panel {
    transition: width 0.25s;
    flex-grow: 1;
    background-color: #F7F4F1;
    overflow: auto;
}
.main-panel1 {
    position: relative;
    height: calc(100vh - 60px);
    overflow: auto;
}
.container-all {
    background-color: #F7F4F1;
}
.sidebar {
    transition: width 0.25s;
    background-color: #F7F4F1;
    height: 100vh;
    z-index: 1000;
}
.topbar {
    height: 60px;
    border-bottom: 3px solid #E9E6E4;
    background-color: white;
}
</style>
